import React from "react";

import { routerObjectShape } from "../interfaces/componentTypes";

export class GoalRouter {
  public routerOptions: routerObjectShape[];
  constructor(t) {
    this.routerOptions = [
      {
        id: 0,
        name: "observationForm",
        containerName: "observationContainer",
        type: "GoalTemplateObservation",
        navOptions: ["preview", "cancel"],
      },
      {
        id: 1,
        name: "observationPreview",
        type: "GoalTemplateObservation",
        containerName: "observationContainer",
        navOptions: ["edit", "save", "cancel"],
      },
      {
        id: 2,
        name: "interviewForm",
        type: "GoalTemplateInterview",
        containerName: "interviewContainer",
        navOptions: ["preview", "cancel"],
      },
      {
        id: 3,
        name: "interviewPreview",
        type: "GoalTemplateInterview",
        containerName: "interviewContainer",
        navOptions: ["edit", "save", "cancel"],
      },
      {
        id: 4,
        name: "educationForm",
        type: "GoalTemplateEducation",
        containerName: "educationContainer",
        navOptions: ["preview", "cancel"],
      },
      {
        id: 5,
        name: "educationPreview",
        type: "GoalTemplateEducation",
        containerName: "educationContainer",
        navOptions: ["edit", "save", "cancel"],
      },
    ];
  }

  goToHomepage() {
    return {
      name: "homepage",
      type: "homepage",
      containerName: "homepage",
      navOptions: [],
    };
  }

  goToForm(formType, CRUDType, formDefaults = null) {
    let route = this.routerOptions.find((option) => option.type == formType);
    route.CRUDType = CRUDType;
    route.formDefaults = formDefaults;
    return route;
  }

  goToPreview(currentForm) {
    let route = this.routerOptions.find(
      (option) => option.id == currentForm.id + 1
    );
    route.CRUDType = currentForm.CRUDType;
    return route;
  }

  goToEditCurrent(currentForm) {
    let route = this.routerOptions.find(
      (option) => option.id == currentForm.id - 1
    );
    route.CRUDType = currentForm.CRUDType;
    return route;
  }

  goToEditTemplate(template, CRUDType) {
    let route = this.routerOptions.find(
      (option) =>
        option.type == template.type.name && option.name.includes("Form")
    );
    route.formDefaults = template;
    route.CRUDType = CRUDType;
    return route;
  }
}
